// extracted by mini-css-extract-plugin
module.exports = {"canIdentifyAndDelete":"AdditionalParty_canIdentifyAndDelete__2oNyY","deleteButton":"AdditionalParty_deleteButton__330QJ","marginBotton":"AdditionalParty_marginBotton__31gZI"};